<div class="wrap">
  <form [formGroup]="updateUserForm" (ngSubmit)="onSubmit()" *ngIf="!confirmUpdateUser">
    <h2>Modification infos utilisateur</h2>

    <div class="info_user">
      <ion-avatar>
        <img [src]="imgUserDefault" />
      </ion-avatar>
      <div><span [style.margin-right.px]="10">{{updateUserForm.get('lastname').value}}</span>
        <span>{{updateUserForm.get('firstname').value}}</span>
      </div>
    </div>

    <mat-slide-toggle [color]="color" [checked]="isActive" (change)="userIsActiveOrNot()">
      {{isActiveValue? "Actif": "Inactif"}}
    </mat-slide-toggle>

    <div class="username_choice_picture">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>{{'addUser.username.label' | translate}}</mat-label>
        <input matInput formControlName="username" (input)="isInactive($event.target.value)">
      </mat-form-field>
      <div class="choice_picture">
        <fa-icon [icon]="faCamera"></fa-icon>
        <input matinput type="file" class="input_picture" formControlName="imgUser"
          (input)="isInactive($event.target.value)" (change)="convertImage($event)">
      </div>
    </div>

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Nom</mat-label>
      <input matInput formControlName="lastname" (input)="isInactive($event.target.value)">
    </mat-form-field>

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Prénom</mat-label>
      <input matInput formControlName="firstname" (input)="isInactive($event.target.value)">
    </mat-form-field>

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>{{'updateUser.changepassword.label' | translate}}</mat-label>
      <input matInput id="password" formControlName="password" placeholder="Ce champ n'est pas obligatoire"
        (input)="isInactive($event.target.value)">
    </mat-form-field>


    <mat-form-field appearance="outline">
      <mat-label>{{'updateUser.role.label' | translate}}</mat-label>
      <mat-select formControlName="role" (selectionChange)="isInactive($event.value)">
        <mat-option *ngFor="let r of roles" [value]="r.name">{{r.description}}</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="steps" *ngIf="updateUserForm.get('role').value !== 'admin'">
      <mat-checkbox *ngFor="let s of steps" [checked]="s.stepValid" [color]="color" (click)="addOrRemoveStep(s)">
        {{s.name}}</mat-checkbox>
    </div>


    <div class="btn_action">
      <button type=" submit" [ngClass]="{isInactive: inactive, isActive: !inactive }" [disabled]="inactive"
        matdialogclose>
        Mettre à jour l'utilsateur
      </button>
      <button class="canceled" type="button" (click)="dialogRef.close()">Annuler</button>
    </div>
  </form>


  <div class="confirm" *ngIf="confirmUpdateUser">
    <div class="validation_mail">
      <div class="check">
        <span class="icon-line line-tip"></span>
        <span class="icon-line line-long"></span>
        <div class="icon-circle"></div>
        <div class="icon-fix"></div>
      </div>
    </div>
    <h4>{{'updateUser.confirmUpdateUser.label' | translate}}</h4>
  </div>
</div>